import styles from '../../assets/css/redirection.module.css';
import RedirectButton from './RedirectButton';
import StepHeader from '../StepHeader';
import { useTranslation } from 'react-i18next';
import { REDIRECTION_PREFIX } from '../../utils/translationPagePrefix';
import useCustomization from '../../hooks/useCustomization';
import { CustomizationKey } from '../../contexts/CustomizationsContext';

const FORWARDING_PAGE_SUBTITLE_KEY: CustomizationKey = 'FORWARDING_PAGE_SUBTITLE';

interface RedirectionProps {
	bankName: string;
	bankLogo?: string;
	onRedirection(): void;
}

const Redirection = ({ onRedirection, bankName, bankLogo }: RedirectionProps) => {
	const { t } = useTranslation();

	const subtitle = useCustomization(FORWARDING_PAGE_SUBTITLE_KEY);

	const title = t(`${REDIRECTION_PREFIX}.title`, { bankName });
	return (
		<div id="redirection-step" className={styles['redirection-container']}>
			<StepHeader title={title} subtitle={subtitle} bankName={bankName} bankLogo={bankLogo} />
			<div className={styles['redirection-div-element']} style={{ marginTop: '25px' }}>
				<RedirectButton onClick={onRedirection} />
			</div>
		</div>
	);
};

export default Redirection;
